import { useEffect, useRef } from 'react';
import { useGenericBi } from './use-generic-bi';

/**
 * Fires the `outreach_search` click ONCE per search session — on the query's blank→non-blank
 * transition — rather than on every keystroke. Shared by the Outreach Contacts and Inbox lists so the
 * "did they search, and on which tab" funnel joins across surfaces (iOS/Android fire the same
 * `outreach_search` with the same `tab`).
 *
 * The previous value is seeded from the CURRENT query, so mounting with an existing query (e.g. a tab
 * switch that carries the toolbar's text over) is not itself counted as a transition — only a real
 * blank→non-blank change the user makes reports.
 */
export function useSearchStartedBi(query: string, tab: 'contacts' | 'inbox'): void {
  const { logPageClickBi } = useGenericBi();
  const prevRef = useRef((query ?? '').trim());

  useEffect(() => {
    const cur = (query ?? '').trim();
    const prev = prevRef.current;
    prevRef.current = cur;
    if (!prev && cur) {
      logPageClickBi({ page_name: 'contacts', button_name: 'outreach_search' }, { additionalFields: { tab } });
    }
  }, [query, tab, logPageClickBi]);
}
